import React, { useEffect, useMemo } from "react";
import "./index.style.less";
import PropTypes from "prop-types";
import { useSidebarContext } from "../../../../utility/AppContextProvider/SidebarContextProvider";
import useGetSetting from "hooks/apis/settings/useGetSetting";

const defaultLogo = "/assets/images/apollo.png";
const defaultFavicon = "/assets/images/apollo.png";

const setLinkHref = (selector, rel, href) => {
  if (!href) return;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const setMeta = (property, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[property='${property}']`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const AppLogo = ({ hasSidebarColor }) => {
  const { sidebarColorSet } = useSidebarContext();
  const { dataInfoSetting } = useGetSetting();

  const logoUrl = useMemo(() => dataInfoSetting?.rich?.logo?.url || defaultLogo, [dataInfoSetting]);
  const faviconUrl = useMemo(() => dataInfoSetting?.rich?.favicon?.url || defaultFavicon, [dataInfoSetting]);

  useEffect(() => {
    // Update favicon and apple-touch-icon
    setLinkHref("link[rel='icon']", "icon", faviconUrl);
    setLinkHref("link[rel='apple-touch-icon']", "apple-touch-icon", faviconUrl);
    // Update og:image
    setMeta("og:image", logoUrl || faviconUrl);
    // Update loader/site-logo image if present
    try {
      const loaderImg = document.querySelector(".site-logo img");
      if (loaderImg && (logoUrl || faviconUrl)) loaderImg.src = logoUrl || faviconUrl;
    } catch (e) {
      // noop
    }
  }, [logoUrl, faviconUrl]);

  return (
    <div className="app-logo">
      {hasSidebarColor && sidebarColorSet.mode === "dark" ? (
        <img src={logoUrl} alt="app-logo" />
      ) : (
        <img src={logoUrl} alt="app-logo" />
      )}
    </div>
  );
};

export default AppLogo;

AppLogo.propTypes = {
  hasSidebarColor: PropTypes.bool,
};
